import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { notificationResponsibles } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_NOTIFICATIONRESPONSIBLE,
  DELETE_NOTIFICATIONRESPONSIBLE,
  GET_NOTIFICATIONRESPONSIBLES,
  UPDATE_NOTIFICATIONRESPONSIBLE
} from "./actionTypes";
import {
  addNotificationResponsibleFail,
  addNotificationResponsibleSuccess,
  deleteNotificationResponsibleFail,
  deleteNotificationResponsibleSuccess,
  getNotificationResponsiblesFail,
  getNotificationResponsiblesSuccess,
  setState,
  updateNotificationResponsibleFail,
  updateNotificationResponsibleSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchNotificationResponsibles( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, notificationResponsibles, params.toString());
    yield put(setState(false))
    yield put(getNotificationResponsiblesSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getNotificationResponsiblesFail(error));
  }
}

function* updateNotificationResponsible ({payload: notificationResponsibleObj }) {
  try {
    const response = yield call(getTable,`${notificationResponsibles}/${notificationResponsibleObj.id}`);
    yield put(updateNotificationResponsibleSuccess(response));
  } catch (error) {
    yield put(updateNotificationResponsibleFail(error));
  }
}

function* updateNotificationResponsibleStatus ({payload: notificationResponsibleObj }) {
  try {
    const response = yield call(getTable,`${notificationResponsibles}/${notificationResponsibleObj.id}`);
    yield put(updateNotificationResponsibleSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateNotificationResponsibleFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteNotificationResponsible ({payload: notificationResponsibleObj}) {
  try {
    yield put(deleteNotificationResponsibleSuccess(notificationResponsibleObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteNotificationResponsibleFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingNotificationResponsible ({ payload: notificationResponsible}) {
  try {
    const response = yield call(postApiCall, notificationResponsibles ,notificationResponsible);
    const response1 = yield call(getTable,`${notificationResponsibles}/${response.id}`);
    yield put(addNotificationResponsibleSuccess(response1));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addNotificationResponsibleFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* notificationResponsiblesSaga() {
  yield takeEvery(GET_NOTIFICATIONRESPONSIBLES, fetchNotificationResponsibles);
  yield takeEvery(ADD_NEW_NOTIFICATIONRESPONSIBLE, postingNotificationResponsible);
  yield takeEvery(UPDATE_NOTIFICATIONRESPONSIBLE, updateNotificationResponsible);
  yield takeEvery(UPDATE_NOTIFICATIONRESPONSIBLE, updateNotificationResponsibleStatus);
  yield takeEvery(DELETE_NOTIFICATIONRESPONSIBLE, deleteNotificationResponsible);
}

export default notificationResponsiblesSaga;
